// DOM CustomEvent the admin-app shell dispatches when an `UPLOAD_EDITOR_READY` WS message
// arrives on the org channel. The readiness popup (React island) listens for it on `document`.
// The admin-app side redeclares the same string (it cannot import from content-studio),
// mirroring the OPEN_NEW_CONTENT_MODAL_EVENT convention.
export const UPLOAD_EDITOR_READY_EVENT = 'cl:upload-editor-ready';

// DOM CustomEvent the admin-app shell dispatches from the universal click→API gate (spec §4.2)
// when a clicked, still-processing upload should be surfaced in the popup. Unlike the WS event
// it also carries project/title so the popup can adopt a (possibly older) upload as active.
export const READINESS_SHOW_STATUS_EVENT = 'cl:readiness-show-status';

// DOM CustomEvent the editor dispatches on mount to dismiss any open readiness popup.
// Covers all entry flows (SessionPreview click, direct URL, popup's own "Open Editor" button).
export const READINESS_DISMISS_EVENT = 'cl:readiness-dismiss';

// Single combined message shown while `upload_editor_status === PROCESSING` (spec §4.2 — no
// per-item checklist).
export const READINESS_PROCESSING_MESSAGE = 'Transcript, preview & chapters are being generated.';

export const READINESS_READY_MESSAGE = 'Your recording is ready to edit.';
